import React, { Fragment } from 'react';
import Members from './Members';
import _uniqBy from "lodash-es/uniqBy";	
import { CloseMessageInfoDetailsHoc, EmptyDeliverHoc, OpenMessageInfoDetailsHoc } from '../../../../assets/images';
/**
 * import { uniqBy as _uniqBy } from "lodash";
 */
const DeliveredMessageWrapper = (props = {}) => {
    const { deliveredMembers = [], totalMembers = 0, rosterData } = props;
    const deliveredMemberList = _uniqBy(deliveredMembers, "userId");
    return (
        <Fragment>
            <div className="deliveredDetailsContainer">
                <input type="checkbox" id="deliveredDetails" />
                <label htmlFor="deliveredDetails">
                    <i className="OpenMessageInfoDetails"><OpenMessageInfoDetailsHoc viewBox="0 0 23.807 23.807"/></i>
                    <i className="CloseMessageInfoDetails"><CloseMessageInfoDetailsHoc viewBox="0 0 24.001 24.001"/></i>
                    {`Delivered to ${deliveredMemberList.length} of ${totalMembers}`}
                </label>
                {deliveredMemberList.length === 0 &&
                    <div className="emptyDelivered">
                        <i><EmptyDeliverHoc /></i>
                        <span>No message delivered yet!</span>
                    </div>
                }
                {deliveredMemberList.length > 0 &&
                    <div>
                        <ul className="chat-list-ul">
                            {
                                deliveredMemberList.map(member => {
                                    const { userId, deliveredTime } = member
                                    return <Members time={deliveredTime} rosterData={rosterData} key={userId} jid={userId} />
                                })
                            }
                        </ul>
                    </div>
                }
            </div>
        </Fragment>
    );
}

export default DeliveredMessageWrapper;
